import React, {Component} from 'react';
import {FormattedMessage, injectIntl} from "react-intl";

class FormJobPagePredilectionInput extends Component
{
    render() {

        const { business_unit } = this.props;
        const { intl } = this.props;

        let predilection_label =
            intl.formatMessage({
                id: "portfolio.form_job.predilection.sales.label",
                defaultMessage: "Outils de prédilection"
            });

        let predilection_placeholder =
            intl.formatMessage({
                id: "portfolio.form_job.predilection.tech.placeholder",
                defaultMessage: "Ex: PHP, Laravel, Ruby, MySQL..."
            });

        switch (business_unit) {
            case 'tech':
                predilection_label =
                    intl.formatMessage({
                        id: "portfolio.form_job.predilection.tech.label",
                        defaultMessage: "Techno de prédilection"
                    });
                break;
            case 'sales':
                predilection_placeholder =
                    intl.formatMessage({
                        id: "portfolio.form_job.predilection.sales.placeholder",
                        defaultMessage: "Ex : Salesforce, Hubspot, Crunchbase..."
                    });
                break;
            case 'marketing':
                predilection_placeholder =
                    intl.formatMessage({
                        id: "portfolio.form_job.predilection.marketing.placeholder",
                        defaultMessage: "Ex : Google Analytics, Adwords, LinkedIn..."
                    });
                break;
            case 'product':
                predilection_label =
                    <FormattedMessage
                        id="portfolio.form_job.predilection.product.label"
                        defaultMessage="Vous souhaitez travailler sur une solution..."
                    />;

                predilection_placeholder =
                    intl.formatMessage({
                        id: "portfolio.form_job.predilection.product.placeholder",
                        defaultMessage: "Ex : Saas, Logiciel, Mobile..."
                    });
                break;
            case 'design':
                predilection_placeholder =
                    intl.formatMessage({
                        id: "portfolio.form_job.predilection.design.placeholder",
                        defaultMessage: "Ex : Indesign, AfterEffect, Photoshop..."
                    });
                break;
            default:
                predilection_label =
                    intl.formatMessage({
                        id: "portfolio.form_job.predilection.tech.label",
                        defaultMessage: "Techno de prédilection"
                    });
        }

        return (
            <>
                <label>{predilection_label}*</label>
                <textarea
                    {...this.props}
                    className="input-field"
                    placeholder={predilection_placeholder}
                ></textarea>
            </>
        )
    }
}

export default injectIntl(FormJobPagePredilectionInput);
